<div class="flex flex-col gap-3">
  @for (group of days(); track group.key) {
    <section class="flex flex-col gap-1.5">
      <!-- Opaque: cards scroll under this, and a translucent heading shows their borders through it. -->
      <header class="sticky top-0 z-10 flex items-center gap-2 bg-neutral-0 py-1">
        <span
          class="text-sm font-semibold text-neutral-500 tabular-nums"
          [matTooltip]="'guaranteeV2.message.dayGroupHint' | translate: { count: group.visits.length }"
          >{{ group.timestamp | date: "d MMMM yyyy" }}</span
        >
        @if (group.visits.length > 1) {
          <guarantees-chip
            tone="neutral"
            icon="event"
            [tooltip]="'guaranteeV2.message.visitCountHint' | translate: { count: group.visits.length }"
            >{{ group.visits.length }}</guarantees-chip
          >
        }
        <span class="h-px flex-1 bg-neutral-200"></span>
      </header>

      <!--
        A window of a whole history is thousands of nodes, nearly all of them off screen, so a card
        is built when it comes into view. The placeholder is sized from the line count the timeline
        already reports, which keeps the scrollbar honest instead of letting the page grow under the
        pointer. A chain link renders its target immediately — it is followed before it is seen.
      -->
      @for (visit of group.visits; track visit.guaranteeId) {
        @defer (on viewport; when visit.guaranteeId === focusedGuaranteeId()) {
          <guarantees-stream-visit
            [visit]="visit"
            [readOnly]="readOnly()"
            [focused]="visit.guaranteeId === focusedGuaranteeId()"
            (caseOpened)="caseOpened.emit($event)"
            (detailsOpened)="detailsOpened.emit($event)"
            (prescriptionDetailsOpened)="prescriptionDetailsOpened.emit($event)"
          ></guarantees-stream-visit>
        } @placeholder {
          <div
            class="rounded-xl border border-neutral-200 bg-neutral-0"
            [style.height.px]="placeholderHeight(visit)"
          ></div>
        }
      }
    </section>
  }
</div>
